<template>
  <div class="autocomplete-box bool-card" :style="[ {left: `${caretCoords.x - 10}px` }, {top: `${caretCoords.y + 24}px` } ]">
    <ul>
      <li v-for="(item, index) in sortedQueries"
          :key="`select-option-${index}`"
          class="flex"
          :class="{isSelected : selectedOption && item.value === selectedOption.value && item.key === selectedOption.key}"
          @click="$emit('selectQuery', item.value)"
      >
        <span><strong>{{item.key}}</strong>: </span>
        <span>{{item.label}}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "AutoCompleteSuggestionBox",

  props: {
    sortedQueries: {
      type: Array,
      required: true
    },
    matchQuery: {
      type: Object
    },
    caretCoords: {
      type: Object,
      default: () => {}
    },
    isOpen: {
      type: Boolean
    }
  },

  created() {
    this.syntaxEditor = this.$parent.$refs['editor-syntax']
    window.addEventListener('keydown', this.keyupHandler);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handler);
  },

  data() {
    return {
      syntaxEditor: null,
      selectedOption: null,
      parentWidth: 0,
      width: 0,
      left: 0,
      top: 0,
    }
  },

  methods: {
    keyupHandler(e) {
      if(!this.isOpen || this.sortedQueries.length === 0) {
        if(this.selectedOption) this.selectedOption = null;
        return;
      }

      const taskKeys = [13, 27, 38, 40];

      // if this suggestion box is visible, disable scrolling on arrow action
      if((this.sortedQueries.length && taskKeys.indexOf(e.keyCode) > -1)) {
        e.preventDefault()
        this.$emit('preventDefaultEscape', true);
      }

      if(e.keyCode === 40) return this.selectNext() // ArrowDown
      if(e.keyCode === 38) return this.selectPrevious() // ArrowUp
      if(e.keyCode === 13) return this.selectOption() // Enter
      else return this.reset(); //Anything that is not arrows up/down or enter would close autocomplete (including ESC)
    },

    selectPrevious() {
      if(this.sortedQueries.length) {
        const idX =  this.selectedOption ? this.sortedQueries.findIndex(item => item.value === this.selectedOption.value && item.key === this.selectedOption.key) : null;

        if(idX === 0 || !this.selectedOption) return this.selectLastOption();
        else if(idX !== -1 && this.sortedQueries[idX - 1]) return this.selectedOption = this.sortedQueries[idX - 1]
      }

      this.$emit('reset')
    },

    selectNext() {
      if(this.sortedQueries.length) {
        const idX = this.selectedOption ? this.sortedQueries.findIndex(item => item.value === this.selectedOption.value && item.key === this.selectedOption.key) : null;

        if(idX >= this.sortedQueries.length - 1 || !this.selectedOption) return this.selectFirstOption();
        else if(idX !== -1 && this.sortedQueries[idX + 1]) return this.selectedOption = this.sortedQueries[idX + 1]
      }

      this.$emit('reset')
    },

    selectOption() {
      if(this.selectedOption && this.selectedOption.value) this.$emit('selectQuery', this.selectedOption.value && this.selectedOption.value.trim())
    },

    selectFirstOption() {
      if(this.sortedQueries.length) this.selectedOption = this.sortedQueries[0]
    },

    selectLastOption() {
      if(this.sortedQueries.length) this.selectedOption = this.sortedQueries[this.sortedQueries.length -1]
    },

    reset () {
      if(this.selectedOption) this.selectedOption = null;
      this.$emit('reset');
    }
  },
}
</script>